import { defineStore } from "pinia";
import {
  getProfileAccountManagement,
  updateProfileAccountManagement,
  getViewListUser,
  deleteUser,
  getRoleUser,
  createNewUser,
  editUser,
  getViewEditUser,
  resetPasswordUser,
  resendInvite,
  getListCity,
  getListDistricts,
  getStoreDetail,
  updateStore,
  updateProgress,
  updateDocuments,
  getDocuments,
  reverseGeocode,
  createTemporaryStaff,
  getStoreDetailEmbed,
} from "@/api/accountManagement";
import { transformToFormDataDynamic, isFile } from "@/utils/global.util";

export const useProfileFormStore = defineStore({
  id: "profile",
  state: () => ({
    type: null,
    storeDetailsData: null,
    sellType: "package",
    progress: {
      stepsVerifyPackages: 0,
      stepsVerifyVouchers: 0,
    },
    infoForm: {
      // county: null,
      // currency: null,
      nameEn: null,
      nameTh: null,
      shortNameEn: null,
      shortNameTh: null,
      primaryPhone: null,
      secondaryPhone: null,
      openingHours: null,
      openingHoursEn: null,
      openingHoursTh: null,
      website: null,
      descriptionEn: null,
      descriptionTh: null,
      hotelInformation: null,
      experienceInformation: null,
      branch: null,
      operatingHoursStart: null,
      operatingHoursEnd: null,
    },
    contactPerson: {
      yourName: null,
      yourPhone: null,
      yourRole: null,
      yourEmail: null,
    },
    photoManagement: {
      logo: null,
      cover: null,
      thumbnails: [],
    },
    cuisineForm: {
      oldPrimaryId: null,
      primaryId: null,
      cuisineIds: [],
    },
    diningStyleForm: {
      oldPrimaryDiningStyle: [],
      primaryDiningStyle: null,
      diningStyleIds: [],
    },
    locationForm: {
      locationInGg: "",
      address: "",
      lat: 0,
      lng: 0,
      cityId: 0,
      districtId: 0,
      popularZoneIds: [],
      shoppingMallId: 0,
      btsRouteId: [],
      mrtRouteId: [],
      locationIds: [],
      primaryLocationId: null,
    },
    facilitiesForm: {
      facilityIds: [],
    },
    location: {
      listCity: [],
      listDistrict: [],
    },
    profileForm: {
      avatar: null,
      firstName: null,
      email: null,
      role: null,
      lastName: null,
      oldPassword: "",
      newPassword: "",
      status: null,
      joined: null,
      lastSeen: null,
      platform: null,
      convertJoined: null,
      calculateDate: null,
      phone: {
        countryCode: null,
        phoneNumber: null,
      },
      contactNumber: null,
      data: [],
      pagination: {},
    },
    listRoleUser: [],
    defineListRole: [],
    documentsSteps: {
      typeOfEnterprise: null,
      documents: {
        certificatePp20: {
          file: null,
          id: null,
        },
        certificateDbd: {
          file: null,
          id: null,
        },
        identificationCard: {
          file: null,
          id: null,
        },
        bankbook: {
          file: null,
          id: null,
        },
        eContract: {
          file: null,
          id: null,
        },
      },
    },
    allowBookingWithoutPackage: false,
    acceptKids: false,
    isFetching: false,
    userList: [],
    pagination: {},
  }),
  getters: {
    currencyCode: (state) => state.storeDetailsData?.countryCode || "TH", // Default to TH if not set
    getViewProfileAccountManagement: (state) => state.profileForm,
    inventorySource: (state) => state.storeDetailsData?.inventorySource || null,
  },
  actions: {
    getProfileAccountManagement() {
      return new Promise((resolve, reject) => {
        getProfileAccountManagement()
          .then((response) => {
            const profileDetails = response.data.attributes;
            this.profileForm.firstName = profileDetails.firstName;
            // console.log('aaaa',this.firstName);
            this.profileForm.lastName = profileDetails.lastName;
            this.profileForm.email = profileDetails.email;
            this.profileForm.role = profileDetails.role;
            this.profileForm.status = profileDetails.status;
            this.profileForm.joined = profileDetails.createdAt;
            this.profileForm.lastSeen = profileDetails.lastSignInAt;
            this.profileForm.platform = profileDetails.lastPlatformStayIn;
            this.profileForm.phone.countryCode = profileDetails.phone.countryCode;
            this.profileForm.phone.phoneNumber = profileDetails.phone.phoneNumber;
            this.profileForm.avatar = profileDetails.avatarUrl;
            // console.log(`profileDetails`, this.platform);
            this.profileForm.contactNumber =
              profileDetails.phone.countryCode + profileDetails.phone.phoneNumber;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleEditProfile(payload) {
      return new Promise((resolve, reject) => {
        updateProfileAccountManagement(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getViewListUser(payload) {
      return new Promise((resolve, reject) => {
        getViewListUser(payload)
          .then((response) => {
            const fmt2 = new Intl.DateTimeFormat("en-GB", {
              year: "numeric",
              day: "numeric",
              month: "short",
              hour: "numeric",
              minute: "numeric",
            });
            const dataFormat = response.data.map((item) => {
              const { attributes, id, type } = item;
              const phone = attributes.phone || {};
              const phoneDisplay =
                phone.countryCode || phone.phoneNumber
                  ? `${phone.countryCode ?? ""}${phone.phoneNumber ?? ""}`.trim()
                  : null;
              const dataItem = {
                id: id,
                type: type,
                userId: id,
                name: attributes.name,
                email: attributes.email,
                role: attributes.role,
                phone: phoneDisplay,
                status: attributes.status,
                position: attributes.position ?? null,
                customPosition: attributes.customPosition ?? null,
                notificationTypes: attributes.notificationTypes ?? [],
                createdAt: attributes.createdAt
                  ? fmt2.format(new Date(attributes.createdAt))
                  : null,
                lastOnline: attributes.lastSignInAt,
                expiredAt:
                  attributes.role === "Temporrary Access" && attributes.expiredAt
                    ? `Valid until ${fmt2.format(new Date(attributes.expiredAt))}`
                    : null,
              };
              return dataItem;
            });
            this.userList = dataFormat;
            this.pagination = response.meta;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteUser(payload, restaurantId) {
      return new Promise((resolve, reject) => {
        deleteUser(payload, restaurantId)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getRoleUser() {
      return new Promise((resolve, reject) => {
        getRoleUser()
          .then((response) => {
            this.listRoleUser = response.roles;
            this.defineListRole = this.listRoleUser.map((role) => {
              return {
                value: role,
                label: role,
              };
            });
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createNewUser(payload, restaurantId) {
      return new Promise((resolve, reject) => {
        createNewUser(payload, restaurantId)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editUser(id, payload, restaurantId) {
      return new Promise((resolve, reject) => {
        editUser(id, payload, restaurantId)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getViewEditUser(id, restaurantId) {
      return new Promise((resolve, reject) => {
        getViewEditUser(id, restaurantId)
          .then((response) => {
            resolve(response.data?.attributes);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    resendInvite(id, restaurantId) {
      return new Promise((resolve, reject) => {
        resendInvite(id, restaurantId)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    resetPasswordUser(payload) {
      return new Promise((resolve, reject) => {
        resetPasswordUser(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListCity(payload) {
      return new Promise((resolve, reject) => {
        getListCity(payload)
          .then((response) => {
            if (!response || !response.data) {
              resolve(false);
              return;
            }
            const dataFormat = response.data.map((item) => {
              const { attributes } = item;
              const dataItem = {
                value: attributes.id,
                title: attributes.name,
              };
              return dataItem;
            });
            this.location.listCity = dataFormat;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListDistricts(payload) {
      return new Promise((resolve, reject) => {
        getListDistricts(payload)
          .then((response) => {
            if (response?.success) {
              const dataFormat = response.data?.map((item) => {
                const { attributes } = item;
                const dataItem = {
                  value: attributes.id,
                  title: attributes.name,
                };
                return dataItem;
              });
              this.location.listDistrict = dataFormat;
            }

            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // getLogoDetail() {
    //   return new Promise((resolve, reject) => {
    //     getStoreDetail()
    //       .then((response) => {
    //         const { attributes } = response.data;
    //         this.storeDetailsData = attributes;
    //         resolve(true);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
    getStoreDetailEmbed(payload) {
      return new Promise((resolve, reject) => {
        getStoreDetailEmbed(payload)
          .then((response) => {
            const { attributes } = response.data;
            this.acceptKids = attributes.acceptKids ?? false;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getStoreDetail(payload) {
      return new Promise((resolve, reject) => {
        getStoreDetail(payload)
          .then((response) => {
            const { attributes } = response.data;
            this.storeDetailsData = attributes;

            const assignProgressSteps = (attributeName, defaultValue = 0) => {
              return attributes[attributeName] || defaultValue;
            };
            this.progress.stepsVerifyPackages = assignProgressSteps("stepsVerifyPackages");
            this.progress.stepsVerifyVouchers = assignProgressSteps("stepsVerifyVouchers");

            this.type = attributes.outletType;

            // info form
            this.infoForm.nameEn = attributes.nameEn;
            this.infoForm.nameTh = attributes.nameTh;
            this.infoForm.shortNameEn = attributes.shortNameEn;
            this.infoForm.shortNameTh = attributes.shortNameTh;
            this.infoForm.descriptionEn = attributes.miscEn;
            this.infoForm.descriptionTh = attributes.miscTh;

            const locale = window.localStorage.getItem("locale");
            const getOpeningHours = (locale, attributes) => {
              return locale === "en" ? attributes.openingHoursEn : attributes.openingHoursTh;
            };
            this.infoForm.openingHours = getOpeningHours(locale, attributes);

            this.infoForm.openingHoursEn = attributes.openingHoursEn;
            this.infoForm.openingHoursTh = attributes.openingHoursTh;
            this.infoForm.website = attributes.website;

            this.photoManagement.logo = attributes.logoUrl;
            this.photoManagement.cover = attributes.imageCoverUrl;
            this.photoManagement.thumbnails = attributes.thumbnails;

            const formatPhoneNumber = (phone) => {
              if (!phone) return null;
              const countryCode = attributes.countryCode || "th";
              const phoneCode = countryCode === "sg" ? "+65" : "+66";
              return phone.slice(0, 3).trim() === phoneCode ? phone.slice(3).trim() : phone.trim();
            };
            this.infoForm.primaryPhone = formatPhoneNumber(attributes.phone);
            this.infoForm.secondaryPhone = formatPhoneNumber(attributes.secondaryPhone);

            this.infoForm.hotelInformation = attributes.hotelInformation;
            this.infoForm.experienceInformation = attributes.experienceInformation;

            const getContactPersonAttribute = (attribute) => {
              return attribute || null;
            };
            // contact person
            this.contactPerson.yourEmail = getContactPersonAttribute(
              attributes.contactPerson?.email,
            );
            this.contactPerson.yourName = getContactPersonAttribute(attributes.contactPerson?.name);
            this.contactPerson.yourPhone = formatPhoneNumber(attributes.contactPerson?.phone);

            this.contactPerson.yourRole = attributes.contactPerson?.role || null;

            const extractIds = (tags) => {
              return tags?.map((item) => item.id) || [];
            };
            const updateFilterTagIdsWithPrimary = (filterTagIds, primaryId) => {
              if (primaryId && !filterTagIds.includes(primaryId)) {
                filterTagIds.push(primaryId);
              }
              return filterTagIds;
            };

            // cuisine form
            this.cuisineForm.cuisineIds = extractIds(attributes.cuisines);
            this.cuisineForm.primaryId = attributes.primaryCuisine?.id;
            this.cuisineForm.oldPrimaryId = attributes.primaryCuisine?.id;
            this.cuisineForm.cuisineIds = updateFilterTagIdsWithPrimary(
              this.cuisineForm.cuisineIds,
              this.cuisineForm.primaryId,
            );

            // dining style form
            this.diningStyleForm.diningStyleIds = extractIds(attributes.diningStyles);
            this.diningStyleForm.primaryDiningStyle = attributes.primaryDiningStyle?.id;
            this.diningStyleForm.oldPrimaryDiningStyle = attributes.primaryDiningStyle?.id;
            this.diningStyleForm.diningStyleIds = updateFilterTagIdsWithPrimary(
              this.diningStyleForm.diningStyleIds,
              this.diningStyleForm.primaryDiningStyle,
            );

            // location form
            this.locationForm.cityId = attributes.location?.cityId;
            this.locationForm.districtId = attributes.location?.districtId;
            this.locationForm.locationInGg = attributes.location?.googleMapLink;

            const parseCoordinate = (coordinate) => {
              return parseFloat(coordinate || 0);
            };
            this.locationForm.lat = parseCoordinate(attributes.lat);
            this.locationForm.lng = parseCoordinate(attributes.lng);

            this.locationForm.address = attributes.location?.address;
            this.locationForm.popularZoneIds = extractIds(attributes.popularZones);
            this.locationForm.locationIds = extractIds(attributes.locations);

            const extractLocationId = (attribute, defaultValue = null) => {
              return attribute?.id || attribute?.[0]?.id || defaultValue;
            };
            this.locationForm.primaryLocationId = extractLocationId(attributes.primaryLocation);
            this.locationForm.btsRouteId = extractLocationId(attributes.btsRoutes);
            this.locationForm.mrtRouteId = extractLocationId(attributes.mrtRoutes);
            this.locationForm.shoppingMallId = extractLocationId(attributes.shoppingMalls);

            // facilities form
            this.facilitiesForm.facilityIds = extractIds(attributes.facilities);

            this.allowBookingWithoutPackage = attributes.allowBookingWithoutPackage ?? false;
            this.acceptKids = attributes.acceptKids ?? false;

            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateStore(payload) {
      return new Promise((resolve, reject) => {
        updateStore(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addThumbnailItem() {
      this.photoManagement.thumbnails.push({
        id: new Date().getTime(),
        url: null,
        priority: null,
      });
    },
    deleteThumbnailItem(id) {
      this.photoManagement.thumbnails = this.photoManagement.thumbnails.filter(
        (item) => item.id != id,
      );
    },
    updateDocuments({ restaurantId }) {
      const formData = new FormData();
      const { typeOfEnterprise, documents } = this.documentsSteps;
      const documentsData =
        Object.entries(documents).map((value) => {
          if (!value[1].file && !value[1].id) return null;

          if (!isFile(value[1].file) && value[1].id) {
            if (value[1].isDestroy) {
              return {
                id: value[1].id,
                isDestroy: true,
              };
            }
            return {
              id: value[1].id,
            };
          }

          let isDestroy = null;
          if (isFile(value[1].file)) {
            isDestroy = false;
          } else if (value[1].isDestroy) {
            isDestroy = true;
          }
          return {
            id: value[1].id || null,
            file: value[1].file || null,
            name: value[0] || null,
            isDestroy: isDestroy,
          };
        }) || [];

      const payload = {
        typeOfEnterprise: typeOfEnterprise,
        documents: transformToFormDataDynamic(documentsData, formData, "documents"),
        restaurantId,
      };

      const postData = transformToFormDataDynamic(payload, formData, null);
      return new Promise((resolve, reject) => {
        updateDocuments(postData)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    resetDocument() {
      this.documentsSteps = {
        typeOfEnterprise: null,
        documents: {
          certificatePp20: {
            file: null,
            id: null,
          },
          certificateDbd: {
            file: null,
            id: null,
          },
          identificationCard: {
            file: null,
            id: null,
          },
          bankbook: {
            file: null,
            id: null,
          },
          eContract: {
            file: null,
            id: null,
          },
        },
      };
    },
    getDocuments(payload) {
      this.resetDocument();
      return new Promise((resolve, reject) => {
        getDocuments(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }

            if (response?.data.length) {
              const docsData = response.data?.reduce((groups, item) => {
                if (!groups[item.attributes.name]) {
                  groups[item.attributes.name] = {};
                }
                groups[item.attributes.name] = {
                  id: item.id,
                  file: item.attributes.file,
                  isDestroy: false,
                };

                return groups;
              }, {});
              this.documentsSteps.typeOfEnterprise = response?.enterpriseType || null;
              this.documentsSteps.documents = {
                ...this.documentsSteps.documents,
                ...docsData,
              };
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateProgress({ restaurantId }) {
      const payload = {
        stepsVerify: {
          packages: this.progress.stepsVerifyPackages,
          vouchers: this.progress.stepsVerifyVouchers,
        },
        restaurantId,
      };
      return new Promise((resolve, reject) => {
        updateProgress(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAddressFromLatLng(payload) {
      return new Promise((resolve, reject) => {
        reverseGeocode(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createTemporaryStaff(restaurantId) {
      return new Promise((resolve, reject) => {
        createTemporaryStaff(restaurantId)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
});
